import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const reportingRevenueOverTimePeriodAPI = async (params: {
  startDate: string;
  endDate: string;
  format: string;
}) => {
  const response = await baseAPI.get<string>(
    '/reporting/revenue-over-time-period',
    {
      params,
      responseType: 'text',
    },
  );
  return response.data;
};

export const useReportingRevenueOverTimePeriod = (params: {
  startDate: string;
  endDate: string;
  format: string;
}) => {
  return useQuery({
    queryKey: [
      KEYS.REVENUE_OVER_TIME_PERIOD,
      params.startDate,
      params.endDate,
      params.format,
    ],
    queryFn: () => reportingRevenueOverTimePeriodAPI(params),
    enabled: !!params.startDate && !!params.endDate && !!params.format,
  });
};
